import React, { useEffect, useState } from 'react';

import { bodyScrollOverflowHidden, bodyScrollOverflowAuto } from './helper';

import MainBlock from './sections/main_block/MainBlock';
import WhatWillYouGetBlock from './sections/what-will-you-get_block/WhatWillYouGetBlock';
import decor from './assets/img/decor.png';
import MentorBlock from './sections/mentor_block/MentorBlock';
import TopBlock from './sections/top-block/TopBlock';
import HowDoesItWork from './sections/how-does-it-work_block/HowDoesItWork';
import ResultsBlock from './sections/results_block/ResultsBlock';
import FooterBlock from './sections/footer_block/FooterBlock';
import InfoBlock from './sections/info-block/InfoBlock';
import PriceBlock from './sections/price_block/PriceBlock';
import Menu from './sections/menu/Menu';
import { getDocBd } from './firebase';

import LoaderPage from './components/LoaderPage/LoaderPage';
import Cat from './components/Cat/Cat';

export default function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dataInfo, setDataInfo] = useState({
    telegtamGropLink: '',
    startDateGroup: '',
  });
  const [loaderPage, setLoaderPage] = useState(true);

  useEffect(() => {
    // setLoaderPage(true);
    const getGroupInfo = async () => {
      const groupInfo = await getDocBd('site', 'groupInfo');
      if (groupInfo) {
        const date = new Date(groupInfo.startDateGroup);
        setDataInfo({
          telegtamGropLink: groupInfo.telegtamGropLink,
          startDateGroup: date.toLocaleDateString(),
        });
      }
      setLoaderPage(false);
    };
    getGroupInfo();
  }, []);

  const toggleMenu = (value) => {
    setMenuOpen(value);

    if (value) {
      bodyScrollOverflowHidden();
    } else {
      bodyScrollOverflowAuto();
    }
  };

  return (
    <div>
      {loaderPage ? (
        <LoaderPage />
      ) : (
        <>
          <div className="container_top">
            <Cat />
            <TopBlock toggleMenu={toggleMenu} />
          </div>
          <div className="site_wrapper">
            <MainBlock dataInfo={dataInfo} />
            <img className="img-decor" src={decor} />

            <WhatWillYouGetBlock />
            <HowDoesItWork />
            <MentorBlock />
            <img className="img-decor" src={decor} />
            <PriceBlock dataInfo={dataInfo} />
            <ResultsBlock />
            <img className="img-decor" src={decor} />
            <InfoBlock />
            <FooterBlock />
          </div>
          {/* {menuOpen ? <Menu menuOpen={menuOpen} toggleMenu={toggleMenu} /> : ''} */}
          <Menu menuOpen={menuOpen} toggleMenu={toggleMenu} />
        </>
      )}
    </div>
  );
}
